module.exports = __webpack_public_path__ + "static/media/instapage21.bce774da.png";